import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefreshScaleService } from 'app/core/services/refresh-scale/refresh-scale.service';
import { SalaryScaleService } from 'app/core/services/salary-scale.service';

@Component({
  selector: 'dialog-delete-scale',
  templateUrl: './dialog-delete-scale.component.html',
  styleUrls: ['./dialog-delete-scale.component.scss']
})
export class DialogDeleteScaleComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteScaleComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private salaryScaleService: SalaryScaleService, private refreshScaleService: RefreshScaleService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteElement() {
    this.isLoading = true;
    this.salaryScaleService.deleteScale(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshScaleService.emitRefresh(this.data.index);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

}
